<template>
  <ul class="documents-list">
    <li v-for="document in documents" :key="document.id">
      <a
        :href="document.file.url"
        class="document"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>
          <span class="document__label">{{ document.label }}</span>
          <span class="document__meta">{{ document.file.mime }} · {{ filesize(document.file.size) }}</span>
        </span>

        <span class="actions">
          <t-button
            small
            type="grey"
            class="document__button"
            outlined
          >
            <t-icon icon="eye" />
          </t-button>
          <t-button
            v-if="canDelete"
            small
            class="document__button"
            type="danger"
            @click.stop.prevent="$emit('delete', document.id)"
            outlined
          >
            <t-icon icon="trash" />
          </t-button>
        </span>
      </a>
    </li>
  </ul>
</template>

<script>
import DashboardImage from '~/components/DashboardImage';
import { filesize } from 'filesize';

export default {
  components: {
    DashboardImage,
  },

  props: {
    documents: {
      type: Array,
      required: true,
    },

    canDelete: {
      type: Boolean,
      default: false,
      required: false,
    }
  },

  data: () => ({
    filesize,
  }),
};
</script>
<style lang="scss">
.documents-list {
  list-style: none;
  padding: 0;

  > li + li {
    margin-top: $s-2;
  }
}

.document {
  padding: $s-4;
  border: 1px solid var(--outline-color);
  border-radius: $border-radius;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: bold;
  align-items: center;
  transition: border-color 0.2s ease-out;

  &:hover {
    border-color: var(--primary-color);
  }

  &__label {
    display: block;
  }

  &__meta {
    text-decoration: none;
    color: var(--grey-color);
    font-weight: normal;
  }

  &__icon {
    color: var(--grey-color);
    padding: $s-2;
  }

  &__button {
    min-width: 0;
  }
}
</style>
